import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import api from '@/api/api.js'
// import "@/api/message.js";

// Vue.prototype.$message = Message;
Vue.config.productionTip = false
Vue.use(ElementUI, { locale: enLocale })
Vue.prototype.$api = api

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
